import { ListFilters, listFilterQuery } from "../types/listFilters";
// src/services/customerService.ts
import apiClient from './apiClient';
import { CustomerApiResponse, CustomerDetailApiResponse } from '../types/customer';
import { toLegacyListResponse } from '../utils/normalizePaginatedResponse';
import type { Customer } from '../types/customer';
import { readPage } from '../utils/paginatedResult';

export const getCustomers = async (
  page = 1,
  search = '',
  isActive = '',
  limit = 9,
  filters: ListFilters = {}
): Promise<CustomerApiResponse> => {
  try {
    const params: Record<string, string | number | boolean> = { page, limit, ...listFilterQuery(filters, ["startDate", "endDate", "isVerified", "isKycVerified"]) };
    if (search) params.search = search;
    if (isActive === "true" || isActive === "false") params.isActive = isActive === "true";

    const response = await apiClient.get('customers', { params });
    return toLegacyListResponse<Customer, 'customers'>(response.data, 'customers');
  } catch (error) {

    throw error;
  }
};

export const getCustomerById = async (id: string): Promise<CustomerDetailApiResponse> => {
  try {
    const response = await apiClient.get(`customers/${id}`);
    const body = response.data as Record<string, unknown>;
    const customer = body?.customer ?? body?.data ?? body;
    return { customer: customer as CustomerDetailApiResponse['customer'] };
  } catch (error) {

    throw error;
  }
};

export async function toggleCustomerStatus(id: string): Promise<{ user: Pick<Customer, 'id' | 'isActive'> }> {
  return (await apiClient.patch(`customers/${encodeURIComponent(id)}/toggle-status`)).data;
}

export async function getCustomerHistory<T>(id: string, kind: 'shipments' | 'referral-earnings' | 'referral-wallet-earnings', page: number, signal?: AbortSignal) {
  return readPage<T>((await apiClient.get(`customers/${encodeURIComponent(id)}/${kind}`, { params: { page, limit: 20 }, signal })).data);
}
